import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useEffect, useState } from 'react';
import { Input, Label, Button } from "reactstrap";
import cx from 'classnames';
import requestApi from "../services/requestApi.service";
import { handleErrorResponse, showToast } from '../Common/Appcommon';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

function CTCLogo() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [fromNumber, setFromNumber] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [fromUser,setFromUser] = useState('');
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    const openFilterModal = () => {
        setIsModalOpen(true);
    };

    const closeFilterModal = () => {
        setIsModalOpen(false);
        setInputValue('');
        setPhoneNumber('');
        setFromNumber('');
        setFromUser('');

    };

    useEffect(() => {
        const fetchSuggestions = async () => {
            try {
                let params = {
                    "ENTITY": "CLOUDTELEPHONYLEADSPROCESS",
                    "OPERATION": 'USER_DROP_DOWN',
                    "isPopup" : true,
                };
                let response = await requestApi.processServerRequest(params, "WebV2");
                let suggestion = response.data[0];
                let filteredSuggestions = suggestion.filter(s => s !== 'sadmin');
                setSuggestions(filteredSuggestions);
            } catch (error) {
                handleErrorResponse('Failed to fetch suggestions');
            }
        };

        fetchSuggestions();
    }, []);

    const handleUserChange = async (name) => {
        let userName = name.target.value;
        userName = userName.split("(",2);
        let Name = userName[0];
        let params = {
            "ENTITY": "CLOUDTELEPHONYLEADSPROCESS",
            "OPERATION": 'GET_USER_MOBILE',
            "Name": Name,
        };
        let response = await requestApi.processServerRequest(params, "WebV2");
        if (response.issuccess) {
            let mobile = response.data.toNumber['Mobile'];
            let fromNo = response.data['fromNumber'];
            let fromUser = response.data['fromUser'];
            setFromUser(fromUser);
            setFromNumber(fromNo);
            setPhoneNumber(mobile);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setInputValue(suggestion);
        handleUserChange({ target: { value: suggestion } });
        setFilteredSuggestions([]);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (value) {
            const filtered = suggestions.filter((suggestion) =>
                suggestion.toLowerCase().startsWith(value.toLowerCase())
            );
            setFilteredSuggestions(filtered);
        } else {
            setFilteredSuggestions([]);
        }
    };

    const handleClick = () => {
        if (phoneNumber !== '' && fromNumber !== '' && inputValue !== '') {
            closeFilterModal();
            clicktoCall();
        } else {
            let errorMsg = '';
            if(inputValue === ''){
                errorMsg = 'Please Choose User';
            } else if (phoneNumber === '') {
                errorMsg = 'Please Provide Mobile Number';
            } else if (fromNumber === '') {
                errorMsg = 'Please Provide From Number';
            }
            handleErrorResponse(errorMsg);
        }
    };

    const clicktoCall = async () => {
        let params = {
            "ENTITY": "cloud_Telephoney",
            "OPERATION": 'clicktocall',
            "fromno": fromNumber,
            "tono": phoneNumber,
        };
        let response = await requestApi.processServerRequest(params, "WebV2");
        if (response.data.status === "success") {
            let message = response.errormsg;
            showToast(message);
        } else {
            handleErrorResponse('Call Not Initiated');
        }
    };

    return (
        <Fragment>
            <div className="ui-theme-settings">
                <div className={cx("iframe-container", { 'hide': !isModalOpen })}>
                    <div className="container-header aster-header">
                        Internal Click 2 Call
                        <button aria-label="Close" className="btn-close" onClick={closeFilterModal}></button>
                    </div>
                    <div className="aster-div">
                        <Label className='aster-label'>From Name</Label>
                        <Input className='aster' type='text' value={fromUser} readOnly />
                        <Label className='aster-label'>From Number</Label>
                        <br />
                        <Input className='aster' type='text' value={fromNumber} readOnly />
                        <Label className='aster-label'>To Whom</Label>
                        <Input
                            className='aster'
                            type="text"
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                        {filteredSuggestions.length > 0 && (
                            <ul className="aster drop-down-list form-control" style={{ position: 'absolute', top: 'calc(61% + 5px)', zIndex: 9999 }}>
                                {filteredSuggestions.map((suggestion, index) => (
                                    <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                        {suggestion}
                                    </li>
                                ))}
                            </ul>
                        )}
                        <Label className='aster-label'>To Number </Label>
                        <Input className='aster' type='text' value={phoneNumber} readOnly />
                        <br />
                        <Button color="success" className={`aster-center`} onClick={handleClick}>
                            Call
                        </Button>
                    </div>
                </div>
                <button onClick={openFilterModal} className={cx("btn-open-options btn btn-warning", { 'hide': isModalOpen })} type="button" id="TooltipDemo">
                    <FontAwesomeIcon icon={faHeadset} />
                </button>
            </div>
        </Fragment>
    );
}

export default CTCLogo;
